











import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Header extends Vue {
  @Prop({ type: Boolean, default: false }) on!: boolean

  @Prop({ type: Boolean, default: false }) inline!: boolean

  @Prop({ type: [ Object, String ], default: null }) to!: object | string
}
